import * as React from 'react';

import Tooltip from 'components/Tooltip';
import MediaPreview from 'components/MediaPreview';

type Props = {
  url: string,
  thumbnailUrl: string,
  caption: string
};

const SentimentAnalysisMediaPreview = ({
  thumbnailUrl,
  url,
  caption
}: Props) => (
  <Tooltip
    textAlign="left"
    width="extra-long"
    message={caption}
  >
    <MediaPreview
      width={32}
      height={32}
      attachment={{
        id: 1,
        url: thumbnailUrl,
        externalUrl: url,
        format: 'image'
      }}
    />
  </Tooltip>
);

export default SentimentAnalysisMediaPreview;
